import type { ReliabilityStatus, ReliabilityViewModel } from "./types";
import { t } from "../i18n";

const reliabilityMap: Record<ReliabilityStatus, Omit<ReliabilityViewModel, "status" | "title" | "description">> = {
  reliable: {
    canShowPreview: true,
    canStartMonitoring: true,
    requiresUserAction: false,
  },
  probably_reliable: {
    canShowPreview: true,
    canStartMonitoring: true,
    requiresUserAction: false,
  },
  confirmation_required: {
    canShowPreview: true,
    canStartMonitoring: true,
    requiresUserAction: false,
  },
  degraded: {
    canShowPreview: true,
    canStartMonitoring: true,
    requiresUserAction: false,
  },
  incomplete_data: {
    canShowPreview: true,
    canStartMonitoring: false,
    requiresUserAction: false,
  },
  provider_error: {
    canShowPreview: false,
    canStartMonitoring: false,
    requiresUserAction: true,
  },
  private_profile: {
    canShowPreview: false,
    canStartMonitoring: false,
    requiresUserAction: true,
  },
  paused_unreliable: {
    canShowPreview: false,
    canStartMonitoring: false,
    requiresUserAction: false,
  },
  unknown: {
    canShowPreview: false,
    canStartMonitoring: false,
    requiresUserAction: false,
  },
};

export function getReliabilityViewModel(status: ReliabilityStatus): ReliabilityViewModel {
  const model = reliabilityMap[status];
  return {
    status,
    title: t(`reliability_${status}`),
    description: t(`reliability_${status}_desc`),
    ...model,
  };
}

export function getReliabilityStatusFromAvailability(
  isPrivate: boolean,
  hasError: boolean,
  hasData: boolean,
): ReliabilityStatus {
  if (isPrivate) return "private_profile";
  if (hasError) return "provider_error";
  if (!hasData) return "incomplete_data";
  return "reliable";
}
